jQuery(document).ready(function ($) {

    let currentProductId;
    let currentOnetimeProductId;
    let currentSubscriptionProductId;
    let currentPopupId;
    let currentProductTitle;
    let currentOnetimePrice;
    let currentSubscriptionPrice;
    let currentVariationId;
    let currentSubscriptionPeriod;
    let currentProductDescription;
    let currentOnetimeVariationId;
    let currentSubscriptionVariationId;
    let baseProductItem;

    $(document).on('elementor/popup/show', function () {


        if ($('.purovitalis-sidecart-content').length > 0) {
            // Update product title and prices
            $('.purovitalis-sidecart-content .purovitalis-sidecart__title').html(currentProductTitle);

            $('.purovitalis-sidecart-content .purovitalis-sidecart__description').html(currentProductDescription);

            // Set variaton id for onetime and subscription

            // Populate One time product form fields
            $('.purovitalis-sidecart-content .purovitalis-sidecart__onetime .purovitalis-sidecart__price').html(baseProductItem.find('.purovitalis-add-to-cart-form__sidecart-pricing-item--onetime .purovitalis-add-to-cart-form__sidecart-pricing-item-price').text());
            $('.purovitalis-sidecart-content .purovitalis-sidecart__onetime form input[name="add-to-cart"]').val(currentOnetimeProductId);
            $('.purovitalis-sidecart-content .purovitalis-sidecart__onetime form input[name="product_id"]').val(currentOnetimeProductId);
            $('.purovitalis-sidecart-content .purovitalis-sidecart__onetime form input.variation_id').val(currentOnetimeVariationId);

            // Populate Subscription product form fields
            $('.purovitalis-sidecart-content .purovitalis-sidecart__subscription .purovitalis-sidecart__price').html(baseProductItem.find('.purovitalis-add-to-cart-form__sidecart-pricing-item--subscription .purovitalis-add-to-cart-form__sidecart-pricing-item-price').text());
            $('.purovitalis-sidecart-content .purovitalis-sidecart__subscription form input[name="add-to-cart"]').val(currentSubscriptionProductId);
            $('.purovitalis-sidecart-content .purovitalis-sidecart__subscription form input[name="product_id"]').val(currentSubscriptionProductId);
            $('.purovitalis-sidecart-content .purovitalis-sidecart__subscription form input.variation_id').val(currentSubscriptionVariationId);
            $('.purovitalis-sidecart-content .purovitalis-sidecart__subscription .purovitalis-sidecart__price-container__price-period').text('/' + currentSubscriptionPeriod);
        }
    });

    $('.custom-add-to-cart-button').on('click', function (e) {

        e.preventDefault();

        // Send precart event to Plausible
        if (typeof plausible !== 'undefined') {
            plausible('precart');
        }

        // Prevent default behavior of parent overlay elements
        $(this).closest('.jet-woo-item-overlay-wrap').off('click');
        $('.jet-woo-item-overlay-link').off('click');

        currentOnetimeProductId = $(this).data('onetime-product-id');
        currentSubscriptionProductId = $(this).data('subscription-product-id');
        currentPopupId = $(this).data('popup-id');
        currentProductTitle = $(this).data('product-title');
        currentOnetimePrice = $(this).data('onetime-price');
        currentSubscriptionPrice = $(this).data('subscription-price');
        currentProductDescription = $(this).data('product-description');
        currentOnetimeVariationId = $(this).data('onetime-variation-id');
        currentSubscriptionVariationId = $(this).data('subscription-variation-id');
        currentSubscriptionPeriod = $(this).data('subscription-period');
        baseProductItem = $(this).parent();

        elementorProFrontend.modules.popup.showPopup({ id: currentPopupId });


        // Manually trigger Plausible for the pre-cart sidebar buttons
        document.querySelector('.purovitalis-sidecart__onetime-button').addEventListener('click', function (e) {
            if (typeof plausible !== 'undefined') {
                plausible('AddToCart');
            }
        }, true);

        document.querySelector('.purovitalis-sidecart__subscription-button').addEventListener('click', function (e) {
            if (typeof plausible !== 'undefined') {
                plausible('AddToCart');
            }
        }, true);

    });
});